/**
 * Categorical colours in fixed order (the dataviz reference palette, checked
 * for colour-blind separation on a light surface). A series keeps its slot
 * across filters: the caller assigns slots, never the rank.
 */
export const SERIES_COLOURS = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7'];
/** "Others", and anything that is context rather than a series. */
export const NEUTRAL = '#9ca3af';
